<template>
  <a-select :labelInValue="needLabel" :value="selectedValue" @change="handleChange" :style="extraStyle" :disabled="disabled"
            :placeholder="placeholder" :show-search="showSearch" :filter-option="filterOption" :allowClear="allowClear">
    <template v-for="(item,index) in list">
      <a-select-option :key="index" :value="item.value">
        {{ item.label }}
      </a-select-option>
    </template>
  </a-select>
</template>

<script>
export default {
  name: 'AppSelect',
  model: {
    prop: 'selectedValue',
    event: 'changeSelect'
  },
  props: {
    list: {
      type: Array,
      default: () => []  // {label: '',value: ''}
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    selectedValue: {
      type: [String, Object, Number]
    },
    extraStyle: {
      type: String,
      default: 'width: 176px;margin-right: 10px;'
    },
    needLabel: { // 选中的值里是否带上label，默认不带
      type: Boolean,
      default: false // true: 返回{key: '', label:''},key值即为value值, false: 返回value值
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    handleChange (e) {
      this.$emit('changeSelect', e)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    }
  }
}
</script>

<style scoped>

</style>
